import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StarIcon from '@mui/icons-material/Star';
import {Icon} from "@mui/material"; //@material-ui/core   <AutoAwesomeIcon className="icono"/>

function CajaGenerica(props) {

        const isImage = props.icon.endsWith('.png');

        return (
            <div >
                <div className="caja-texto-grande-rosa">
                    {isImage ? (
                        <img
                            className={"icono"}
                            style={{background: "none"}}
                            src={process.env.PUBLIC_URL + require(`../imagenes/iconos/${props.icon}`)}
                        alt={"img"}/>

                    ) : (
                        <Icon className="icono">{props.icon}</Icon>
                    )}
                    <h2 className={"destacado-rosa"}>{props.destacado}</h2>
                    <div className={"destacado-estrellas"}>
                        <StarIcon className={"estrella"} /><StarIcon className={"estrella"}/><StarIcon className={"estrella"}/><StarIcon className={"estrella"}/><StarIcon className={"estrella"}/><StarIcon className={"estrella"}/>
                    </div>
                    <h2 className={"titulo"} >{props.titulo}</h2>
                    <p className={"descripcion"}>{props.descripcion}</p>
                </div>
            </div>
        );
    }

    export default CajaGenerica;


